
import List from './List.vue'
import ManageContractRoute from '@/views/Contract/ManageContract/router'

export default [
  {
    path: 'list',
    name: 'ContractList',
    component: List
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "contract" */ '@/views/Contract/ManageContract/Index.vue'),
    children: ManageContractRoute
  }
]
